import { render, staticRenderFns } from "./OACloud.vue?vue&type=template&id=523c97b6&scoped=true&"
import script from "./OACloud.vue?vue&type=script&lang=js&"
export * from "./OACloud.vue?vue&type=script&lang=js&"
import style0 from "./OACloud.vue?vue&type=style&index=0&id=523c97b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c97b6",
  null
  
)

export default component.exports